import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'

import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
// import sanitizeHtml from 'sanitize-html'
// import useCsrfToken from '../hooks/useCsrfToken'
import hero from '../assets/images/hero/compras.jpg'
import { LuArrowLeft } from 'react-icons/lu'
// import useAuthStatus from '../hooks/useAuthStatus'
import { Helmet } from 'react-helmet-async'

export default function PedidoDetalle() {
    // const { csrfToken } = useCsrfToken();
    // const { status } = useAuthStatus();
    const csrfToken = localStorage.getItem('token');
    let params = useParams();
    let iden = params.iden;
    // let [activeImage, setImage] = useState('');
    const [pedido, setPedido] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;
    // const stripTagsFromHtml = (html) => {
    //     const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
    //     return sanitizeHtml(html, {
    //         allowedTags: allowedTags
    //     });
    // };

    useEffect(() => {
        // if (csrfToken === null) return;
        const transformData = (data) => {
            const formattedDate = (datedata) => {
                return new Date(datedata).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            }
            const formatPrice = (price) => {
                return price ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0';
            };
            return {
                id: data.id,
                name: data.name,
                orderdate: formattedDate(data.orderdate),
                orderstatus: data.orderstatus,
                ordertotal: formatPrice(data.ordertotal),
                paymentmethod: data.paymentmethod,
                paymentstatus: data.paymentstatus,
                productimage: `${API_URL}${data.product.primary_image}`,
                customername: data.customername,
                branches: data.branches
            };
        };
        fetch(`${API_URL}/api/purchase/${iden}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => {
            if (response.status === 401) {
                window.location.href = '/login';
                return null;
            }
            if (response.status === 404 || response.status === 403) {
                window.location.href = '/pedidos';
                return null;
            }
            return response.json();
        })
            .then(data => {
                if (data) {
                    setPedido(transformData(data));
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, [API_URL, iden, csrfToken]);

    return (
        <>
            <Helmet>
                <title>Mis pedidos | Hospital Aranda de La Parra</title>
                <meta name="description" content="Hospital Aranda de La Parra" />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark mt-4">{pedido.id}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item" aria-current="page"><Link to="/pedidos">Mis Pedidos</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{pedido.id}</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <div className="card border-0 shadow rounded overflow-hidden">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12 text-center mb-4">
                                            <img src={pedido.productimage} className="img-fluid w-25 rounded" alt="" />
                                            <br />
                                            <h4 className="mt-3">{pedido.name}</h4>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <strong># de pedido:</strong> {pedido.id || 'N/A'}
                                            </div>
                                            <div className="mb-3">
                                                <strong>Fecha de compra:</strong> {pedido.orderdate || 'N/A'}
                                            </div>
                                            <div className="mb-3">
                                                <strong>Status:</strong> {pedido.orderstatus === 'completed' ? <span className="badge bg-success">Pagado</span> : pedido.orderstatus === 'fulfilled' ? <span className="badge bg-info">Entregado/Completado</span> : pedido.orderstatus === 'refunded' ? <span className="badge bg-danger">Reemvolsado</span> : <span className="badge bg-dark">Pendiente</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <strong>Total:</strong> ${pedido.ordertotal || 'N/A'}
                                            </div>
                                            <div className="mb-3">
                                                <strong>Método de pago:</strong> {pedido.paymentmethod || 'N/A'}
                                            </div>
                                            <div className="mb-3">
                                                <strong>Ordenado por:</strong> {pedido.customername || 'N/A'}
                                            </div>
                                        </div>
                                        <div className="col-12 text-center mt-5">
                                            <h5 className='fw-bold mb-2'>¿Dónde está mi recibo de pago?</h5>
                                            <div className="text-muted">
                                                <p className='text-center'>Su recibo de pago se envió a su correo electrónico registrado en su cuenta, este proviene directamente de la empresa Stripe®. Si no lo encuentra, revise su carpeta de spam o correo no deseado.</p>
                                            </div>
                                            <h5 className='fw-bold mb-2'>¿Cómo puedo solicitar una factura de esta compra?</h5>
                                            <div className="text-muted">
                                                <p className='text-center'>
                                                    Ingrese a la sección de <Link to='/facturacion'>Facturación</Link>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-12 text-center mt-5">
                                            {pedido.branches && pedido.branches.length > 0 && (
                                                <h5 className='fw-bold my-5'>Este paquete está disponible en:<br />
                                                    {pedido.branches && pedido.branches.map((item, index) => (
                                                        <span key={index} to="#" className="badge badge-link me-1 bg-lightgray">
                                                            {item.title}
                                                        </span>
                                                    ))}
                                                </h5>
                                            )}
                                            <Link to="/contacto" className="btn btn-primary w-50 btn-sm">Contáctenos si necesita ayuda sobre este pedido</Link>
                                            <br /><br />
                                            <Link to="/pedidos" className="btn btn-light w-50 btn-sm">
                                                <LuArrowLeft /> Volver a listado
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <ScrollToTop />
        </>
    )
}
